import React, { Component }  from 'react'
import { default as MarketoImportContainer } from 'containers/MarketoImport'

class MarketoImport extends Component {
  render() {
    return (
      <MarketoImportContainer />
    )
  }
}

export default MarketoImport